import { Box, BoxProps } from "@chakra-ui/react";
import Image from "next/image";

export type GcmsImageFragment = {
  __typename?: "GCMS_Asset";
  id: string;
  url: string;
  width?: number | null;
  height?: number | null;
  handle: string;
};
export interface ImageFragment
  extends Omit<GcmsImageFragment, "width" | "height"> {
  width: number;
  height: number;
  blurDataURL: string;
}

export interface BlogMediaProps extends BoxProps {
  src: string;
  alt: string;
  imageHeight: number;
  imageWidth: number;
  image?: ImageFragment;
}

export const PostMedia = (props: BlogMediaProps) => {
  const { src, alt, image, imageHeight, imageWidth, ...rest } = props;
  return (
    <Box
      w="full"
      overflow="hidden"
      position="relative"
      h={imageHeight}
      {...rest}
    >
      <Image
        className="post-media"
        style={{
          objectFit: "cover",
          objectPosition: "center",
          width: "100%",
          height: imageHeight,
        }}
        src={src}
        width={imageWidth as number}
        height={imageHeight as number}
        alt={alt}
        placeholder={
          typeof image?.blurDataURL === "string" ? "blur" : undefined
        }
        blurDataURL={
          typeof image?.blurDataURL === "string"
            ? image?.blurDataURL
            : undefined
        }
      />
    </Box>
  );
};
